export class ReplyTo {
    Address: string;
}



export class Signataire {
    EMail: string;
    FirstName: string;
    Language: string;
    LastName: string;
}

export class Definition {
    ApplicationName: string;
    DocumentId: string;
    DocumentTitle: string;
    ExpirationTime: Date;
    SendCallback: boolean;
    Signataire: Signataire;
    SigningField: string;
    SigningTypes: string;
    SourceDocumentName: string;
    TargetDocumentDocumentum: any[];
    TargetDocumentPath: string;
    TargetDocumentSharepoint: any[];
    FniceNo: string;
}

export class SignDocument {
    definition: Definition;
}

export class Body {
    SignDocument: SignDocument;
}

export class DigitalSignature {
    Signataire: Signataire;
    FniceNo:string
}
